import React, { useState, useRef, useEffect } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ClientSideRowModelModule } from "ag-grid-community";
import { ModuleRegistry } from "ag-grid-community";
import { useLocation, useNavigate } from "react-router-dom";
import PMRService from "../../services/pmrservice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from 'react-toastify';


import {
    getgridHeaders,
    getMedicationatDashboard,
    getVitals,
    getMRSitesReports,
    getAllMRSItesReports,
    getLogUserMenuAnalytics, getProviderforAdvanceSearch, getHospitalsforAdvanceSearch,
    getChatHistory,
    updateWidgetSortOrder,
    getProviderWidgetsManagement,
} from "apiServices/reducer/apiService";



import {
    Image as ImageIcon,
    Droplet,
    Heart,
    FileText,
} from 'lucide-react';

import { AllergyCard, UpcomingAppointmentsCard, VaccinationCard } from "components";
import LabResultsCard from 'pageComponents/user/components/labResults';
import Medications from 'pageComponents/user/components/medications';
import Postings from 'pageComponents/user/components/Postings';
import ActiveProblems from 'pageComponents/user/components/ActiveProblems';
import ClinicalRemainders from 'pageComponents/user/components/ClinicalRemainders';
import WomensHealth from 'pageComponents/user/components/WomensHealth';

// Custom tooltip styles
const customTooltipStyles = `
    .custom-tooltip {
        background-color: #2c3e50 !important;
        color: white !important;
        border-radius: 8px !important;
        padding: 8px 12px !important;
        font-size: 14px !important;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
        border: none !important;
        max-width: 200px !important;
        text-align: center !important;
        opacity: 0.95 !important;
        transition: opacity 0.3s ease-in-out !important;
    }

    .custom-tooltip .tooltip-arrow {
        border-color: #2c3e50 !important;
    }

    
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = customTooltipStyles;
document.head.appendChild(styleSheet);

// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const WidgetDashboardManager = (props) => {

    const [activeTab, setActiveTab] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");
    const [togglePDF, setTogglePDF] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false); // State for fullscreen mode

    // Add state for date range picker
    const today = new Date();
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const dispatch = useDispatch()
    const token = useSelector((state) => state.apiService.token);
    const MenuData = useSelector((state) => state.apiService.menuItem);
    const FamilyData = useSelector((state) => state.apiService.familyAccounts);
    const userData = useSelector((state) => state.apiService.login);

    const isProvider = userData?.user_type_name === 'Provider';
    const userId = isProvider ? props.userId : userData?.user_id || '';
    const params = { token: token, user_id: userId };
    const LoggedInUserId = userData?.user_id || '';

    const [showReport, setShowReport] = useState(false);
    const [showDashboard, setShowDashBoard] = useState(true);
    const [showSharedReports, setShowSharedReports] = useState(false);
    const [showBlog, setShowBlog] = useState(false);

    const [showReceipt, setShowReceipt] = useState(false);
    const [showNotes, setShowNotes] = useState(false);



    const [showBMI, setShowBMI] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [rowDatanew, setRowDatanew] = useState([]);


    const [selectedReport, setSelectedReport] = useState(null);
    const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
    const [selectedReportName, setSelectedReportName] = useState(null);
    const [selectedReportID, setSelectedReportID] = useState();
    const [chatHistory, setChatHistory] = useState([]);


    const menuItems = [
        { label: 'Imaging', icon: <ImageIcon className="pmr-menu-icon" />, color: "#e0f2fe", id: 2, parent_id: 2, },
        { label: 'Blood work', icon: <Droplet className="pmr-menu-icon" />, color: "#e0f2fe", id: 3, parent_id: 2 },
        { label: 'Cardiology', icon: <Heart className="pmr-menu-icon" />, color: "#e0f2fe", id: 4, parent_id: 2 },
        { label: 'Prescriptions', icon: <FileText className="pmr-menu-icon" />, color: "#e0f2fe", id: 9, parent_id: 2 },
    ];


    const [gridHeaders, setGridHeaers] = useState([
        { name: 'All', id: 0 },
        { name: 'Imaging', id: 2 },
        { name: 'Blood work', id: 3 },
        { name: 'Cardiology', id: 4 },
        { name: 'Gastroenterology', id: 5 },
        { name: 'Neurology', id: 6 },
        { name: 'Prescriptions', id: 9 }
    ]);
    const [rowDataStatus, setRowDataStatus] = useState(true)
    const [showModal, setShowModal] = useState(false);

    //const [medications, setMedicationData] = useState([{ medication: "TEST", frequency: "1", startedFrom: new Date(), comments: 'Test Comment', status: 'Active', dose: '500' },]);

    const [medications, setMedicationData] = useState([]);

    const [medication, setMedications] = useState([]);
    const [provider, setProvider] = useState([]);
    const [hospitals, setHospital] = useState([]);

    const [labResults, setLabResults] = useState([

    ]);
    const handleAddClick = () => {
        setShowModal(true); // Show the modal when "Add" is clicked
    };

    const handleModalClose = () => {
        setShowModal(false); // Hide the modal when "Close" is clicked
    };

    const handleSaveMedications = (updatedMedications) => {
        setMedications(updatedMedications); // Save the updated medications list

        setMedicationData(updatedMedications); // Save the updated medications list

        setShowModal(false); // Close the modal after saving
    };

    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedProviders, setSelectedProviders] = useState([]);
    const [selectedHospitals, setSelectedHospitals] = useState([]);
    const [deleteIcon, setDeleteIcon] = useState(false);
    const [deleteTitle, setDeleteTitle] = useState("");
    const [deleteMessage, setDeleteMessage] = useState("");
    const [archiveGeader, setArchiveGeader] = useState("");
    const [showcloseButton, setShowcloseButton] = useState(false);
    const [showShareReportDialog, setShowShareReportDialog] = useState(false);
    const [showEditReportDialog, setShowEditReportDialog] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [showSecondOpinion, setShowSecondOpinion] = useState(false);
    const [showMedicalCondition, setShowMedicalCondition] = useState(false);
    const [showScheduleForChildren, setShowScheduleForChildren] = useState(false);
    const [showScheduleByAge, setShowScheduleByAge] = useState(false);
    const [showTrueContraindications, setShowTrueContraindications] = useState(false);
    const [showAdministeringVaccinesToAdults, setShowAdministeringVaccinesToAdults] = useState(false);


    //const [navItems, setnavItems] = useState();

    const [viewReportData, setViewReportData] = useState({
        ReportGroupName: '',
        ProviderName: '',
        HospitalName: '',
        UserID: userId,
        SearchKey: searchQuery,
        ReportDateStart: null,
        ReportDateEnd: null,
        SiteID: '',
        token: token
    });
    const [logUserMenuAnalyticsData, setLogUserMenuAnalyticsData] = useState({
        MenuID: 3,
        ParentID: 2,
        UserID: 5,
        token: token
    });
    const [deleteparams, setDeleteparams] = useState({
        UserID: userId,
        ReportID: selectedReportID,
        LoginUserID: userId,
        token: token
    })
    const [archiveparams, setArchiveparams] = useState({
        UserID: userId,
        ReportID: selectedReportID,
        LoginUserID: userId,
        token: token
    })
    const [pdfUrl, setPDFURL] = useState()
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state?.data || {};




    const [navItems, setNavItems] = useState([]);
    const [familyItems, setFamilyItems] = useState([]);
    const [showLiveChat, setShowLiveChat] = useState(false);



    const [vitalsValues, setVitalsValues] = useState({
        BloodPressure: "",
        HeartRate: "",
        BloodSugar: "",
        Weight: "",
        WaistSize: "",
    });

    const medicationData = [{ medication: 'TEST', frequency: 1, },];

    const columnDefs = [
        {
            headerName: "Report Name",
            field: "name",
            flex: 2,
            sortable: true,
            filter: true,
            tooltipField: "name",
            headerTooltip: "Report Name",
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold", color: "red" }}>{params.value}</span>
            ) // Render bold red text using React
        },
        {
            headerName: "Report Date",
            field: "date",
            flex: 1,
            sortable: true,
            filter: true,
            tooltipField: "date",
            headerTooltip: "Report Date",
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ) // Render bold text using React
        },
        {
            headerName: "Category",
            field: "category",
            flex: 1,
            sortable: true,
            filter: true,
            tooltipField: "category",
            headerTooltip: "Category",
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ) // Render bold text using React
        },
        {
            headerName: "Clinic/Diagnostics Center",
            field: "clinic",
            flex: 2,
            sortable: true,
            filter: true,
            tooltipField: "clinic",
            headerTooltip: "Clinic/Diagnostics Center",
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold", color: "blue" }}>{params.value}</span>
            ) // Render bold blue text using React
        },
    ];
    const invokeChatHistory = () => {
        setShowLiveChat(true)
        dispatch(getChatHistory(params)).then((resp) => {
            console.log(resp, "for chat history")
            // setChatHistory(resp.payload.Table)
            const chatHistoryData = resp.payload.messages.map(item => ({
                message: item.message,
                sender: item.sender,
                timestamp: item.timestamp
            }))
            setChatHistory(chatHistoryData)
           // console.log(chatHistoryData, "for chat history")

        })
    }

    const onRowClicked = (event) => {
        console.log(event.data, "event.data")
        const reportId = event.data.reportId;
        PMRService.getPMRReportsPerId(reportId).then(resp => {
            const blobUrl = URL.createObjectURL(resp);
            console.log('bloburl', blobUrl)
            setPDFURL(blobUrl)

            setSelectedReport(event.data)
            setSelectedReportName(event.data.name)
            setSelectedReportID(event.data.reportId)
            setDeleteparams({
                UserID: userId,
                ReportID: event.data.reportId,
                LoginUserID: userId,
                token: token
            })
            setArchiveparams({
                UserID: userId,
                ReportID: event.data.reportId,
                LoginUserID: userId,
                token: token
            })
            console.log(selectedReportID, "selectedReportID")
            console.log(deleteparams, "deleteparams in rowCLick")

            setSelectedReport(blobUrl)

        })
        setTogglePDF(!togglePDF);
    };
    // Example with local array
    const groupsList = [
        { id: 'lab', name: 'Lab Report' },
        { id: 'xray', name: 'X-Ray' },
    ];

    const setDashboard = (event) => {

        console.log(event, "event");
        setPDFURL(null)
        setRowData([])
        setRowDatanew([])
        setSearchQuery("")
        setShowAdvanceSearch(false)

        setShowReceipt(false)
        setShowNotes(false);
        console.log(event, "event")



        if (event.parent_id === 2) {
            setShowBMI(false);
            setShowReport(true);
            setShowSharedReports(false);
            setShowDashBoard(false);
            setShowNotes(false);
            setShowSecondOpinion(false);
            setShowProfile(false);
            setShowMedicalCondition(false);
            setShowScheduleForChildren(false);
            setShowScheduleByAge(false);
            setShowTrueContraindications(false);
            setShowAdministeringVaccinesToAdults(false);
            setActiveTab(event.title);
            console.log(viewReportData, "viewReportData for grid at nav")

            dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
                const fetchedData = resp.payload?.Table || [];
                if (fetchedData.length > 0) {
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(prevData => [...prevData, ...formattedDatanew]);
                    setRowDatanew(formattedDatanew);
                }
            });


        } else if (event.menu_id === 23) {

            setShowBMI(true);
            setShowSharedReports(false);
            setShowDashBoard(false);
            setShowReport(false);
            setShowBlog(false);
            setShowNotes(false);
            setShowSecondOpinion(false);
            setShowProfile(false);
            setShowMedicalCondition(false);
            setShowScheduleForChildren(false);
            setShowScheduleByAge(false);
            setShowTrueContraindications(false);
            setShowAdministeringVaccinesToAdults(false);



        } else if (event.parent_id === 12) {
            if (event.menu_id === 13) {
                setShowReceipt(true);
                setShowBMI(false);
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);


            }
        }

        else {
            if (event.menu_id === 1) {
                setShowSharedReports(false);
                setShowDashBoard(true);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);

            } else if (event.menu_id === 0) {
                setShowReport(true);
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);

                dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
                    const fetchedData = resp.payload?.Table || [];
                    if (fetchedData.length > 0) {
                        const formattedDatanew = fetchedData.map(report => ({
                            name: report.report_name,
                            date: report.report_date,
                            category: report.group_name,
                            clinic: report.hospital_name,
                            url: report.report_path,
                            reportId: report.report_id
                        }));
                        setRowData(prevData => [...prevData, ...formattedDatanew]);
                        setRowDatanew(formattedDatanew);
                    }
                });
            } else if (event.menu_id === 3) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);

            } else if (event.menu_id === 4) {
                setShowSharedReports(true);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowNotes(false);
                setShowBMI(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);
            } else if (event.menu_id === 5) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(true);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);
            } else if (event.menu_id === 8) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(true);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);
            } else if (event.menu_id === 21) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(true);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);
            } else if (event.menu_id === 16) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(true);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);

            } else if (event.menu_id === 17) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(true);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);

            } else if (event.menu_id === 18) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(true);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(false);

            }
            else if (event.menu_id === 19) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(true);
                setShowAdministeringVaccinesToAdults(false);

            }
            else if (event.menu_id === 20) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowAdministeringVaccinesToAdults(true);
            }
        }
    }

    const setLogUserMenuAnalytics = (event) => {
        setRowData([]);
        setRowDatanew([]);
        console.log(event, "event");
        const id = event.id;
        const tab = event.label;
        setActiveTab(tab);
        //   if(id===2){
        setShowReport(true);
        setShowSharedReports(false);
        setShowDashBoard(false);
        dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
            const fetchedData = resp.payload?.Table || [];
            if (fetchedData.length > 0) {
                const formattedDatanew = fetchedData.map(report => ({
                    name: report.report_name,
                    date: report.report_date,
                    category: report.group_name,
                    clinic: report.hospital_name,
                    url: report.report_path,
                    reportId: report.report_id
                }));
                setRowData(prevData => [...prevData, ...formattedDatanew]);
                setRowDatanew(formattedDatanew);
            }
        });
        //  }

    }

    const onRefresh = (activeTab) => {
        setActiveTab(activeTab);
        console.log(activeTab, "Name");
        setRowData([]);
        setRowDatanew([])
        setPDFURL(null)
        dispatch(getMRSitesReports(params)).then((resp) => {
            console.log("reportsData", resp.payload);
            const fetchedData = resp.payload.Table;// Use fetched data directly
            if (activeTab === 'All') {
                const formattedData = fetchedData.map(report => ({
                    name: report.report_name,
                    date: report.report_date,
                    category: report.group_name,
                    clinic: report.hospital_name,
                    url: report.report_path,
                    reportId: report.report_id
                }));
                setRowData(prevData => [...prevData, ...formattedData]);
                setRowDatanew(formattedData);// Update rowData with formatted data
            } else {
                const filteredData = fetchedData.filter(report => report.group_name === activeTab);
                const formattedData = filteredData.map(report => ({
                    name: report.report_name,
                    date: report.report_date,
                    category: report.group_name,
                    clinic: report.hospital_name,
                    url: report.report_path,
                    reportId: report.report_id
                }));
                setRowData(prevData => [...prevData, ...formattedData]);
                const formattedDatanew = fetchedData.map(report => ({
                    name: report.report_name,
                    date: report.report_date,
                    category: report.group_name,
                    clinic: report.hospital_name,
                    url: report.report_path,
                    reportId: report.report_id
                }));
                setRowDatanew(formattedDatanew);
                // Update rowData with filtered data
            }
        })
    }

    const includeArchived = (activeTab) => {
        setActiveTab(activeTab);
        console.log(activeTab, "Name");
        setRowData([]);
        setRowDatanew([]);
        setPDFURL(null);

        dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
            console.log("reportsData", resp.payload);
            const fetchedData = resp.payload.Table; // Use fetched data directly

            // Filter data to include only archived reports
            const archivedData = fetchedData.filter(report => !report.is_archived);
            console.log("archivedData", archivedData)


            const formattedData = archivedData.map(report => ({
                //    if(report.is_archived){
                name: report.report_name,
                date: report.report_date,
                category: report.group_name,
                clinic: report.hospital_name,
                url: report.report_path,
                reportId: report.report_id

                //   }

            }));
            setRowData(prevData => [...prevData, ...formattedData]);
            setRowDatanew(formattedData)
            console.log("RowData", rowData)

            //     if (activeTab === 'All') {
            //         setRowData(formattedData); // Update rowData with all archived data
            //     } else {
            //         const filteredData = formattedData.filter(report => report.category === activeTab);
            //         setRowData(filteredData); // Update rowData with filtered archived data
            //     }

            //     setRowDatanew(formattedData); // Update rowDatanew for tab counts
        });
    };

    const setGridData = (event) => {
        setViewReportData({
            ReportGroupName: "",
            ProviderName: "",
            UserID: userId,
            HospitalName: "",
            SearchKey: searchQuery,
            ReportDateStart: "",
            ReportDateEnd: "",
            token: token
        })
        setActiveTab(event.name);
        setSearchQuery("")
        console.log(event.name, "Name");
        setRowData([]);
        setRowDatanew([])
        setPDFURL(null)// Clear rowData before updating
        console.log(viewReportData, "viewReportData for grid")

        dispatch(getAllMRSItesReports(viewReportData))
            .unwrap()
            .then((resp) => {
                console.log("reportsData", resp.payload + viewReportData);
                const fetchedData = resp.payload?.Table || [];

                if (event.name === 'All') {
                    const formattedData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    setRowDatanew(formattedData);
                } else {
                    const filteredData = fetchedData.filter(report => report.group_name === event.name);
                    const formattedData = filteredData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowDatanew(formattedDatanew);
                }
            })
            .catch((error) => {
                console.error("Error fetching reports:", error);
            });
    };

    const onSearch = (event) => {
        setSearchQuery(event.target.value);
        setViewReportData({ ...viewReportData, SearchKey: event.target.value })

        console.log(event.target.value, "event.target.value")
        console.log(viewReportData, "viewReportDataparams")
        // if(event.target.value.length>4){
        setRowData([])
        setRowDatanew([])
        dispatch(getAllMRSItesReports(viewReportData))
            .unwrap()
            .then((resp) => {
                console.log("reportsData123", resp.payload);
                if (resp.payload !== "") {
                    const fetchedData = resp.payload.Table;
                    const formattedData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    setRowDatanew(formattedData)
                }
            })
            .catch((error) => {
                console.error("Error fetching reports:", error);
            });
        //   }

    }
    const onClear = (event) => {
        setSearchQuery(""); // Clear searchQuery
        const updatedViewReportData = { ...viewReportData, SearchKey: "" }; // Clear SearchKey
        setViewReportData(updatedViewReportData); // Update viewReportData

        console.log("Clearing searchQuery and SearchKey");

        setRowData([]);
        setRowDatanew([]);
        dispatch(getAllMRSItesReports(updatedViewReportData))
            .unwrap()
            .then((resp) => {
                console.log("reportsData123", resp.payload);
                if (resp.payload !== "") {
                    const fetchedData = resp.payload.Table;
                    const formattedData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    setRowDatanew(formattedData);
                }
            })
            .catch((error) => {
                console.error("Error fetching reports:", error);
            });
    };

    const handleSearchClear = () => {
        setSearchQuery("");
        onClear();
    };

    const medColumns = [
        { headerName: "Medication", field: "medication",tooltipField: "medication", flex: 1,headerTooltip: "Medication" },
        { headerName: "Frequency", field: "frequency", flex: 1, headerTooltip: "Frequency" ,tooltipField: "frequency"},
    ];

    const labColumns = [
        { headerName: "Report Name", field: "name", flex: 1 , headerTooltip: "Report Name", tooltipField: "name" },
        { headerName: "Report Date", field: "date", flex: 1, headerTooltip: "Report Date", tooltipField: "date" },
    ];


    ///Vitals

    const chartData = {
        lstBPGraph: {
            series: [100, 120, 130, 140, 150, 160],
        },
        lstHeartRateGraph: {
            series: [80, 85, 90, 95, 100, 105],
        },
        // ... other chart data
    };
    const handleAddVitals = () => {
        // Handle adding vitals
    };

    const handleAddMetabolics = () => {
        // Handle adding metabolics
    };

    const handleViewHistory = () => {
        // Handle viewing history
    };

    const handleSlideChange = (eventKey) => {
        // Handle slide change
    };



    // eslint-disable-next-line no-undef
    const [showWidgets, setShowWidgets] = useState(true);
    const [sidebarState, setSidebarState] = useState({});

    const toggleSidebar = (sidebarId) => {
        setSidebarState(prev => ({
            ...prev,
            [sidebarId]: !prev[sidebarId]
        }));
    };
    const [showUploadModal, setShowUploadModal] = useState(false);
    const lstUsersWidgets_Tray = [
        {
            id: 1,
            widget_component: 'app-medical-history',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 2,
            widget_component: 'app-allergies',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 3,
            widget_component: 'app-appointments',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 4,
            widget_component: 'app-vaccination',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 5,
            widget_component: 'app-provider-notes',
            widget_component_class: 'col-lg-6 col-12'
        }
    ];

    const onRemoveUserWidget = (widgetComponent) => {
        setSelectedWidgets(prev =>
            prev.filter(widget => widget.widget_component !== widgetComponent)
        );
    };

    const [lstUsersWidgets_Selected, setSelectedWidgets] = useState([
        {
            id: 1,
            widget_component: 'app-medical-history',
            widget_component_class: 'col-lg-6 col-12'
        }
    ]);

    const handleAddWidget = (widget) => {
        lstUsersWidgets_Selected(prev => [...prev, widget]);
    };

    const IsUserWidget = (widget) => {
        return lstUsersWidgets_Selected.some(w => w.widget_component === widget.widget_component);
    };

    const onAddUserWidget = (widget) => {
        if (!IsUserWidget(widget)) {
            setSelectedWidgets(prev => [...prev, widget]);
        }
    };


    const [seriesData, setSeriesData] = useState([
        { name: 'Systolic', data: [] },
        { name: 'Diastolic', data: [] },
    ]);

    const [seriesDataforHeartRate, setHeartRateData] = useState([
        { name: 'Heart Rate', data: [] },
    ]);

    const [seriesDataforBloodSugar, setBloodSugarData] = useState([
        { name: 'Blood Sugar', data: [] },])

    const [seriesDataforWeight, setWeightData] = useState([
        { name: 'Weight', data: [] },])

    const [seriesDataforWaistSize, setWaistSizeData] = useState([
        { name: 'Waist Size', data: [] },])

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [reportToDelete, setReportToDelete] = useState(null); // Store { id, name }



    const [categoryAdvanceSearch, setCategoryAdvanceSearch] = useState([]);

    const [widgetsMaster, setWidgetsMaster] = useState([]);

    const [loadingWidgets, setLoadingWidgets] = useState(true);

    useEffect(() => {
        console.log(props.isFromDetails, "props.isFromDetails")

        dispatch(getgridHeaders(token))
            .unwrap()
            .then((response) => {
                console.log("Response from getgridHeaders:", response);
                setGridHeaers(response.payload || []);
                const formattedDataforAdvanceSearch = (response.payload || []).map(report => ({
                    name: report.name,
                    id: report.id
                }));
                setCategoryAdvanceSearch(formattedDataforAdvanceSearch);
            })
            .catch((error) => {
                console.error("Error fetching grid headers:", error);
            });

        dispatch(getLogUserMenuAnalytics(logUserMenuAnalyticsData))
            .unwrap()
            .then((response) => {
                console.log("Response from getLogUserMenuAnalytics:", response + logUserMenuAnalyticsData);
            })
            .catch((error) => {
                console.error("Error fetching log user menu analytics:", error);
            });

        console.log(props.userId, "props.userId")
        // Fetch medications
        dispatch(getMedicationatDashboard({
            token: token,
            user_id: userId
        }))
            .unwrap()
            .then((response) => {
                console.log("Full medication response:", response);
                const rawData = response.payload?.Table || [];
                console.log("Raw Medication Data:", rawData);

                if (!Array.isArray(rawData)) {
                    console.error("Expected medication data to be an array but got:", rawData);
                    return;
                }

                const formattedData = rawData.map((medication) => ({
                    MedicationName: medication.medication_name || medication.medication || '',
                    Dose: medication.medication_dose || medication.dose || '',
                    MedicationRecurrence: medication.medication_recurrence || medication.frequency || '',
                    MedicationStartedFrom: medication.medication_started_from || medication.startedFrom
                        ? new Date(medication.medication_started_from || medication.startedFrom)
                        : new Date(),
                    MedicationComments: medication.medication_comments || medication.comments || '',
                    Status: medication.medication_status || medication.status || 'Active',

                    // Raw backend values for grid display
                    medication: medication.medication_name || medication.medication || '',
                    dose: medication.medication_dose || medication.dose || '',
                    frequency: medication.medication_recurrence || medication.frequency || '',
                    startedFrom: medication.medication_started_from || medication.startedFrom || '',
                    comments: medication.medication_comments || medication.comments || '',
                    status: medication.medication_status || medication.status || 'Active'
                }));

                console.log("Formatted medication data:", formattedData);
                setMedicationData(formattedData);
            })
            .catch(error => {
                console.error("Error fetching medications:", error);
            });
        const labdata = {
            user_id: userId,
            token: token
        }
        console.log(labdata, "labdata")


        dispatch(getVitals(params))
            .unwrap()
            .then((response) => {
                const vitalsData = response.payload || [];
                console.log("vitalsDatanew", vitalsData);

                const systolicData = [];
                const diastolicData = [];
                const heartRateData = [];
                const bloodSugarData = [];
                const weightData = [];
                const waistSizeData = [];

                vitalsData.forEach(vital => {
                    if (vital.LastUpdated && vital.BloodPressure_Systolic && vital.BloodPressure_Diastolic) {
                        systolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Systolic]);
                        diastolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Diastolic]);
                    }
                    if (vital.LastUpdated && vital.HeartRate) {
                        heartRateData.push([new Date(vital.LastUpdated).getTime(), vital.HeartRate]);
                    }
                    if (vital.LastUpdated && vital.BloodSugar) {
                        bloodSugarData.push([new Date(vital.LastUpdated).getTime(), vital.BloodSugar]);
                    }
                    if (vital.LastUpdated && vital.Weight) {
                        weightData.push([new Date(vital.LastUpdated).getTime(), vital.Weight]);
                    }
                    if (vital.LastUpdated && vital.WaistSize) {
                        waistSizeData.push([new Date(vital.LastUpdated).getTime(), vital.WaistSize]);
                    }
                });

                setSeriesData([
                    { name: 'Systolic', data: systolicData },
                    { name: 'Diastolic', data: diastolicData },
                ]);
                setHeartRateData([
                    { name: 'Heart Rate', data: heartRateData },
                ]);
                setBloodSugarData([
                    { name: 'Blood Sugar', data: bloodSugarData },
                ]);
                setWeightData([
                    { name: 'Weight', data: weightData },
                ]);
                setWaistSizeData([
                    { name: 'Waist Size', data: waistSizeData },
                ]);

                const latestVital = vitalsData[vitalsData.length - 1] || {};
                setVitalsValues({
                    BloodPressure: latestVital.BloodPressure_Systolic && latestVital.BloodPressure_Diastolic
                        ? `${latestVital.BloodPressure_Systolic}/${latestVital.BloodPressure_Diastolic}`
                        : "N/A",
                    HeartRate: latestVital.HeartRate || "N/A",
                    BloodSugar: latestVital.BloodSugar || "N/A",
                    Weight: latestVital.Weight || "N/A",
                    WaistSize: latestVital.WaistSize || "N/A",
                });
            })
            .catch((error) => {
                console.error("Error fetching vitals:", error);
            });


        if (MenuData && Array.isArray(MenuData)) {
            const updatedNavItems = MenuData.map(item => ({
                menu_id: item.menu_id,
                title: item.title || "Untitled",
                url: item.url || "#",
                parent_id: item.parent_id || null,
                sort_order: item.sort_order || 0,
                type: item.type || ""
            }));
            setNavItems(updatedNavItems);
        }

        if (FamilyData && Array.isArray(FamilyData)) {
            const updatedNavItemsFamily = FamilyData.map(item => ({
                dropdown_display_name: item.dropdown_display_name,
                family_account_id: item.family_account_id || "Untitled",
                relation_type_id: item.relation_type_id || "#",
                relation_type_name: item.relation_type_name || null,
                relative_name: item.relative_name || 0,
                user_id: item.user_id || ""
            }));
            setFamilyItems(updatedNavItemsFamily);
        }

        // Re-implement fullscreen listener setup
        const handleFullscreenChange = () => {
            console.log("Fullscreen change detected. Is fullscreen:", !!document.fullscreenElement);
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
        document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
        document.addEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge

        // Cleanup listener on component unmount
        return () => {
            console.log("Cleaning up fullscreen listener.");
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge
        };
    }, [showDashboard, dispatch, token, logUserMenuAnalyticsData, MenuData, FamilyData, props.isFromDetails, props.isFromReports, userId]); // Added userId to dependencies

    useEffect(() => {
        setLoadingWidgets(true);
        dispatch(getProviderWidgetsManagement({
            user_id: localStorage.getItem('patientUserId'),
            login_user_id: LoggedInUserId,
            token: token
        }))

            .unwrap()
            .then(() => setLoadingWidgets(false))
            .catch(() => setLoadingWidgets(false));
        console.log("getProviderWidgetsManagement", getProviderWidgetsManagement)
    }, [userId, token, dispatch]);

    const onAdvanceSearch = () => {
        const panel = document.querySelector('.advanceSearchcontainer');
        if (panel) {
            panel.style.transition = 'transform 0.3s ease-in-out';
            panel.style.transform = 'translateX(0)';
        }
        setShowAdvanceSearch(true); // Ensure state is updated immediately
        dispatch(getProviderforAdvanceSearch(viewReportData))
            .unwrap()
            .then((resp) => {
                console.log(resp.Table, "provider");
                setProvider(resp.Table);
            })
            .catch((error) => {
                console.error("Error fetching provider data:", error);
            });
        dispatch(getHospitalsforAdvanceSearch(viewReportData))
            .unwrap()
            .then((resp) => {
                console.log(resp.Table, "Hospitals");
                setHospital(resp.Table);
            })
            .catch((error) => {
                console.error("Error fetching hospital data:", error);
            });
    };



    const [draggedWidget, setDraggedWidget] = useState(null);
    const [widgetPositions, setWidgetPositions] = useState({});

    // Fetch widget positions from backend
    const fetchWidgetPositions = async () => {
        try {
            console.log('Fetching widget positions for user:', userId);
            const response = await dispatch(getProviderWidgetsManagement({
                user_id: userId,
                login_user_id: LoggedInUserId,
                token: token
            })).unwrap();
            console.log('getProviderWidgetsManagement API response:', response);
            console.log('Type of response:', typeof response, Array.isArray(response));
            if (response && typeof response === 'object') {
                console.log('Response keys:', Object.keys(response));
            } else {
                console.warn('Response is not an object or is undefined:', response);
            }
            if (response?.Table) {
                const positions = {};
                response.Table.forEach(widget => {
                    positions[widget.widget_id] = {
                        order: widget.sort_order,
                        col: widget.widget_component_class,
                        name: widget.widget_name,
                        isFixed: widget.is_fixed === 1
                    };
                });
                console.log('Setting widgetPositions state:', positions);
                setWidgetPositions(positions);
            } else {
                console.log('No Table property in response or Table is empty:', response);
            }
        } catch (error) {
            console.error('Error fetching widget positions:', error);
        }
    };

    // Initial fetch of widget positions
    useEffect(() => {
        if (userId && token) {
            fetchWidgetPositions();
        }
    }, [userId, token]);

    const handleWidgetDragStart = (e, widgetId) => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('application/json', JSON.stringify({ widgetId }));
        e.currentTarget.style.opacity = "0.5";
    };

    const handleWidgetDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        // e.currentTarget.style.border = "2px dashed var(--pmr-secondary)";
        // e.currentTarget.style.backgroundColor = "rgba(0, 150, 199, 0.1)";
    };

    const handleWidgetDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = "none";
        e.currentTarget.style.backgroundColor = "";
    };

    const handleWidgetDrop = async (e, targetWidgetId) => {
        const data = JSON.parse(e.dataTransfer.getData('application/json'));
        const draggedWidgetId = data.widgetId;

        // Update backend
        await dispatch(updateWidgetSortOrder({
            UserId: userId,
            DraggedWidgetId: draggedWidgetId,
            DraggedWidgetSortOrder: widgetPositions[draggedWidgetId].order,
            TargetWidgetId: targetWidgetId,
            TargetWidgetSortOrder: widgetPositions[targetWidgetId].order,
            LoggedInUserId: LoggedInUserId,
            token: token
        })).unwrap();

        // Refresh positions from backend
        await fetchWidgetPositions();
    };

    const handleWidgetDragEnd = (e) => {
        e.preventDefault();
        e.currentTarget.style.opacity = "1";
        e.currentTarget.style.border = "none";
        e.currentTarget.style.backgroundColor = "";
    };

    const getSortedWidgets = () => {
        return Object.entries(widgetPositions)
            .sort(([, a], [, b]) => a.order - b.order)
            .map(([id]) => id);
    };

    // Update the widget rendering section
    return (
        <>
            <div className="d-flex flex-wrap medicationContainer mb-20" style={{ bottom: '50px !important' }}>
                {loadingWidgets ? (
                    <div className="w-100 text-center text-muted py-5">
                        Loading...
                    </div>
                ) : Object.keys(widgetPositions).length === 0 ? (
                    <div className="w-100 text-center text-muted py-5">
                        No widgets available for your dashboard.
                        <pre>{JSON.stringify(widgetPositions, null, 2)}</pre>
                    </div>
                ) : (
                    getSortedWidgets().map((widgetId) => {
                        const widgetInfo = widgetPositions[widgetId];
                        console.log('Rendering widget:', { widgetId, widgetInfo });
                        if (!widgetInfo) return null;

                        return (
                            <div
                                key={widgetId}
                                className={widgetInfo.col}
                                draggable={!widgetInfo.isFixed}
                                onDragStart={(e) => !widgetInfo.isFixed && handleWidgetDragStart(e, widgetId)}
                                onDragOver={handleWidgetDragOver}
                                onDragLeave={handleWidgetDragLeave}
                                onDrop={(e) => handleWidgetDrop(e, widgetId)}
                                onDragEnd={handleWidgetDragEnd}
                                style={{
                                    cursor: widgetInfo.isFixed ? 'default' : 'move',
                                    padding: '5px',
                                    transition: 'all 0.2s ease',
                                    position: 'relative'
                                }}
                            >
                                <div className="card shadow-lg p-0">
                                    <h6 className="card-header mb-0 fw-bold text-capitalize d-flex justify-content-between align-items-center">
                                        <span>{widgetInfo.name}</span>
                                        {!widgetInfo.isFixed && (
                                            <span className="drag-handle" style={{ padding: '0 5px', userSelect: 'none' }}>
                                                ⋮⋮
                                            </span>
                                        )}
                                    </h6>
                                    <div className="card-body p-0" style={{ height: '290px' }}>
                                        {/* Widget content based on widgetId */}
                                        {widgetId === '5' && (
                                            <Medications
                                                userId={userId}
                                                selectedFamilyMember={props.selectedFamilyMember}
                                                medications={medications}
                                                medColumns={medColumns}
                                                handleAddClick={handleAddClick}
                                                handleAddEdit={handleAddClick}
                                                hideHeader={true}
                                            />
                                        )}
                                        {widgetId === '6' && (
                                            <LabResultsCard
                                                userId={userId}
                                                selectedFamilyMember={props.selectedFamilyMember}
                                                showAddButton={false}
                                                widgetName={widgetInfo.name}
                                                draggable={!widgetInfo.isFixed}
                                                onDragStart={(e) => !widgetInfo.isFixed && handleWidgetDragStart(e, widgetId)}
                                                hideHeader={true}
                                            />
                                        )}
                                        {widgetId === '2' && (
                                            <AllergyCard
                                                showAddButton={false}
                                                widgetName={widgetInfo.name}
                                                draggable={!widgetInfo.isFixed}
                                                onDragStart={(e) => !widgetInfo.isFixed && handleWidgetDragStart(e, widgetId)}
                                                hideHeader={true}
                                            />
                                        )}

                                        {widgetId === '10' && (
                                            <UpcomingAppointmentsCard
                                                showAddButton={false}
                                                widgetName={widgetInfo.name}
                                                draggable={!widgetInfo.isFixed}
                                                onDragStart={(e) => !widgetInfo.isFixed && handleWidgetDragStart(e, widgetId)}
                                                hideHeader={true}
                                            />
                                        )}
                                        {widgetId === '8' && (
                                            <VaccinationCard
                                                showAddButton={false}
                                                widgetName={widgetInfo.name}
                                                draggable={!widgetInfo.isFixed}
                                                onDragStart={(e) => !widgetInfo.isFixed && handleWidgetDragStart(e, widgetId)}
                                                hideHeader={true}
                                            />
                                        )}
                                        {widgetId === '3' && (
                                            <Postings />
                                        )}
                                        {widgetId === '1' && (
                                            <ActiveProblems className='col-md-12' />
                                        )}
                                        {widgetId === '7' && (
                                            <ClinicalRemainders />
                                        )}
                                        {widgetId === '4' && (
                                            <WomensHealth />
                                        )}
                                        {/* Add other widget content conditions based on widgetId */}
                                    </div>
                                    {!isProvider && !widgetInfo.isFixed && (
                                        <div className="card-footer text-start d-flex p-x4">
                                            <span variant="text" className="modalfooterclickeventtext" onClick={handleAddClick}>Add</span>
                                            <span className="mx-2 text-muted">|</span>
                                            <span variant="text" className="modalfooterclickeventtext" onClick={handleAddClick}>Edit</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </>
    );
}

export default WidgetDashboardManager;